import { Alert, Snackbar } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./scenarioApprovalSlice";

export default function MessageForEdit() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.scenarioApproval);
	const { message, severity, messageOpen } = setupState;
	const handleCloseSnackbar = () => {
		dispatch(setState("messageOpen", false));
	};

	return (
		<Snackbar
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			open={messageOpen}
			autoHideDuration={5000}
			onClose={handleCloseSnackbar}
		>
			<Alert
				onClose={handleCloseSnackbar}
				severity={severity}
				sx={{ width: "100%" }}
			>
				{typeof message === "object" ? "Successfull" : message}
			</Alert>
		</Snackbar>
	);
}
